import theme from "../../../styles/theme";
import { cx, css } from "@emotion/css";

export const InputWrapperClass = cx(
  css`
    padding: 0px 12px;
    order: 0;
    display: flex;
  `,
  "aa-InputWrapper"
);

export const InputClass = cx(
  css`
    width: 0;
    flex: 1 0 auto;
  `,
  "aa-Input"
);

export const InputWrapperPrefixClass = cx(
  css`
    order: 2;
  `,
  "aa-InputWrapperPrefix"
);

export const SubmitButtonClass = cx(
  css`
    background: ${theme.colors.blues[100]};
    border: 1px solid ${theme.colors.blues[100]};
  `,
  "aa-SubmitButton"
);

export const LabelClass = cx(
  css`
    svg {
      color: #fff !important;
    }
  `,
  "aa-Label"
);

export const RootClass = css`
  --aa-primary-color-rgb: 14, 106, 237;
  --aa-primary-color-alpha: 0.2;
  --aa-icon-color-rgb: 255, 255, 255;
  --aa-icon-color-alpha: 1;
  --aa-selected-color-rgb: 245, 247, 248;
  --aa-selected-color-alpha: 1;
  --aa-description-highlight-background-color-rgb: 245, 247, 248;
  --aa-description-highlight-background-color-alpha: 1;
`;

export const InputWrapperSuffixClass = cx(
  css`
    order: 1;
  `,
  "aa-InputWrapperSuffix"
);

export const PanelClass = cx(
  css`
    top: initial !important;
    right: initial !important;
    left: 0px !important;
    width: 100% !important;
    border-radius: initial !important;
    box-shadow: 0 2px 8px 0 rgba(37, 56, 66, 0.2) !important;
    z-index: 10;
  `,
  RootClass,
  "aa-Panel"
);

export const PanelLayoutClass = cx(
  css`
    padding: 4px 0px 14px !important;
    li[aria-selected="true"] {
      i {
        display: initial !important;
      }
    }
  `,
  "aa-PanelLayout"
);

export const Source = cx(
  css`
    padding: 12px 0 0 !important;
  `,
  "aa-Source"
);

export const SourceHeader = cx(
  css`
    color: ${theme.colors.darkBlues[75]} !important;
    font-size: ${theme.fontSizes[0]} !important;
    font-weight: ${theme.fontWeights.semibold} !important;
    line-height: ${theme.leading.normal} !important;
    padding: 0px 16px 4px !important;
    display: flex !important;
  `,
  "aa-SourceHeaderTitle"
);

export const ItemClass = cx(
  css`
    min-height: initial !important;
  `,
  "aa-Item"
);

export const ItemLinkClass = cx(css``, "aa-ItemLink");

export const ItemContentClass = cx(
  css`
    padding: 0px 12px !important;
  `,
  "aa-ItemContent"
);

export const ItemContentBodyClass = cx(css``, "aa-ItemContentBody");

export const ItemContentTitleClass = cx(
  css`
    color: ${theme.colors.darkBlues[100]} !important;
    font-size: ${theme.fontSizes[2]} !important;
    line-height: ${theme.leading.normal} !important;
  `,
  "aa-ItemContentTitle"
);

export const ItemActionsClass = cx(
  css`
    color: ${theme.colors.darkBlues[50]} !important;
    padding: 0px 16px !important;
    align-items: center !important;
  `,
  "aa-ItemActions"
);

export const ArrowClass = cx(css`
  display: none !important;
`);

export const SourceHeaderText = cx(css`
  flex: 1 0 auto !important;
`);

export const SourceHeaderViewMore = cx(css`
  flex: 0 1 auto !important;
  color: ${theme.colors.blues[125]} !important;
  text-decoration: none !important;
`);
